﻿import $ from "jquery";
import { GuiBase } from "../GuiBase";
export class GuiOcrResult extends GuiBase {

    constructor() {
        super("Dokument");
    }

    protected attachEvents() {
        $("div.icons img").on("mouseover", (e: JQuery.MouseOverEvent) => { this.mouseOver(e); });
        $("div.icons img").on("mouseout", (e: JQuery.MouseOutEvent) => { this.mouseOut(e); });
        $("button.btn-ocr-page").on("click", (e: JQuery.ClickEvent) => { this.clickOcrPage(e); });
    }


    clickOcrPage(e: JQuery.ClickEvent) {
        this.log("clickOcrPage");
        e.preventDefault();
        
        const btn = $(e.currentTarget) as JQuery;
        let url = $("#ocrdata").data("preview-url").toString();
        const seite = btn.data("seite") as string;
        url = `${url}?seite=${seite}`;

        $("#mdlOcrDokument").remove();

        $.get(url).done(
            (data: string) => {
                const modalDiv = data;
                $("#detailForm").append($(modalDiv));
                $("#mdlOcrDokument").modal("show");
            });
    }

    mouseOver(e: JQuery.MouseOverEvent) {
        const $img = $(e.currentTarget) as JQuery;
        $("div.icons div.card").css({ "z-index": "0" });
        $img.closest(".card").css({ "z-index": "100" });

        const pos = $(e.currentTarget).data("pos");
        const url = $("div.icons").data("previewurl");
        const img = $img[0] as HTMLImageElement;
        const imgUrl = url + "?pos=" + pos;
        $(img).data("iconurl", img.src);
        img.src = imgUrl;
        img.style.transform = "scale(8)";
        img.style.transition = "transform 1s ease";
        img.style.border = ".5px solid grey";
        img.style.zIndex = "1000";
    }

    mouseOut(e: JQuery.MouseOutEvent) {
        //const pos = $(e.currentTarget).data("pos");
        //const url = $("div.icons").data("previewurl");

        const img = ($(e.currentTarget) as JQuery)[0] as HTMLImageElement;

        img.style.transform = "scale(1)";
        img.style.transition = "transform .5s ease";
        img.style.zIndex = "1";
        img.style.border = "";
        img.src = $(img).data("iconurl");
    }

}
